import moment from "moment";

// Export cn utility for easy access
export { cn } from "./cn";

export function getDiscount(price, sellingPrice) {
  return Math.floor(((price - sellingPrice) / price) * 100);
}

export function formatPrice(amount) {
  if (amount == null || amount === "") return "";
  
  const num = Number(amount);
  const decimal = num % 1;
  
  let roundedAmount;
  if (decimal <= 0.5) {
    roundedAmount = Math.floor(num);
  } else {
    roundedAmount = Math.ceil(num);
  }
  
  return roundedAmount.toLocaleString("en-IN");
}

export function isTimeInRange(startTime, endTime) {
  if (!startTime || !endTime) return false;
  const now = moment(); // Get current time
  const start = moment(startTime, "HH:mm"); // Parse startTime
  const end = moment(endTime, "HH:mm"); // Parse endTime

  // Check if endTime is the next day (crosses midnight)
  if (end.isBefore(start)) {
    // Add 1 day to endTime if it crosses midnight
    end.add(1, "day");
  }

  // Check if current time is in the range
  return now.isBetween(start, end);
}

export const clearLocalStorageExcept = ({values}) => {
  if(!Array.isArray(values)) {
    console.log("value is missing, must be an array")
    return
  }
  const preseveKeyValue = {}
  values.forEach((key)=>{
    const value = localStorage.getItem(key)
    if(value !== null) {
      preseveKeyValue[key] = value
    }
  })

  localStorage.clear();

  for(let key in preseveKeyValue) {
    localStorage.setItem(key, preseveKeyValue[key])
  }
}

export const buildCdnURL = (url) => {
  return url?.replace("https://data.kansu.in", "https://d1b9gfdt6jrhan.cloudfront.net")
}

export const isLiterBasedUnit = (title) => {
  if (!title) return false;
  const upperTitle = title.toUpperCase();
  // Check if title contains ML, L (Liter), Tin, or KG patterns
  // This will match: "200 ML", "1 L Bottle", "15 L Tin", "15 KG", etc.
  return /\b\d+\s*(ML|L|KG)\b|\bML\b|\b(L|KG)\s+(Bottle|Pouch|Tetra|Tin)\b/i.test(upperTitle);
}

export const isKGVariant = (title) => {
  if (!title) return false;
  const upperTitle = title.toUpperCase();
  // Check if title contains KG (weight measurement)
  return /\b\d+\s*KG\b|\bKG\b/i.test(upperTitle);
}

export const hasLiquidVariants = (variants) => {
  if (!variants || !Array.isArray(variants)) return false;
  // Check if any variant contains ML or L (liquid measurements)
  return variants.some(variant => {
    const title = variant?.title || variant?.productId?.variant?.title;
    if (!title) return false;
    const upperTitle = title.toUpperCase();
    return /\b\d+\s*(ML|L)\b|\bML\b|\bL\s+(Bottle|Pouch|Tetra|Tin)\b/i.test(upperTitle);
  });
}

export const calculatePricePerUnit = (sellingPrice, weight, weightUnit) => {
  if (!sellingPrice || !weight || !weightUnit) return null;
  
  let normalizedWeight = weight;
  let normalizedUnit = weightUnit.toLowerCase();
  
  // Convert kg to grams
  if (normalizedUnit === 'kg' || normalizedUnit === 'kilogram') {
    normalizedWeight = weight * 1000;
    normalizedUnit = 'g';
  }
  
  // Normalize gram variations to 'g'
  if (normalizedUnit === 'gram' || normalizedUnit === 'grams') {
    normalizedUnit = 'g';
  }
  
  // Convert litre/liter to ml
  if (normalizedUnit === 'l' || 
      normalizedUnit === 'litre' || 
      normalizedUnit === 'liter') {
    normalizedWeight = weight * 1000;
    normalizedUnit = 'ml';
  }
  
  // Normalize milliliter variations to 'ml'
  if (normalizedUnit === 'milliliter' || normalizedUnit === 'millilitre') {
    normalizedUnit = 'ml';
  }
  
  const pricePerUnit = (sellingPrice / normalizedWeight).toFixed(2);
  return `₹${pricePerUnit} / 1 ${normalizedUnit}`;
}

export const formatWeightUnitShort = (unit) => {
  if (!unit) return "";
  const normalized = String(unit).trim().toLowerCase();

  if (normalized === "g" || normalized === "gram" || normalized === "grams") return "g";
  if (normalized === "kg" || normalized === "kilogram" || normalized === "kilograms") return "kg";
  if (normalized === "ml" || normalized === "milliliter" || normalized === "millilitre") return "ml";
  if (normalized === "l" || normalized === "lt" || normalized === "liter" || normalized === "litre") return "l";

  // Fallback: return original trimmed unit
  return String(unit).trim();
};